import { Button, Fade, Grid, IconButton, Modal, Box as MuiBox, Stack, Tab, Tabs, Typography, Divider } from "@mui/material";
import Box from "@mui/material/Box";
import {
    IconArrowLeft,
    IconBookmarks,
    IconEye,
    IconEyeOff,
    IconPresentation
} from '@tabler/icons-react';
import Lottie from "lottie-react";
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import animationData from '../../assets/aiden boat.json';
import SimpleGoogleSlidesPreview from '../../components/SimpleGoogleSlidesPreview';
import { Context as AppContext } from '../../context/AppContext';
import { MainLayout } from "../../layouts/main-layout/MainLayout";
import LessonContentRenderer from './LessonContentRenderer';
import yourLessonJsonData from './tannya_json.json';
import { classToFileMap } from '../../utils/enums-no-imports';

const ClassPage = () => {
    const { className } = useParams();
    const navigate = useNavigate();
    const { state: { modules, componentMapping } } = useContext(AppContext);
    const [yearGroup, setYearGroup] = useState(null);
    const [allClassesForSubject, setAllClassesForSubject] = useState([]);
    const [presentationUrl, setPresentationUrl] = useState(null);
    const [isGeneratingPresentation, setIsGeneratingPresentation] = useState(false);
    const [currentLessonData, setCurrentLessonData] = useState(null);
    const [selectedLesson, setSelectedLesson] = useState(null);
    const [showPreview, setShowPreview] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [modalUrl, setModalUrl] = useState('');
    const [availableYearGroups, setAvailableYearGroups] = useState([]);
    const [applicableClassesForYearGroup, setApplicableClassesForYearGroup] = useState([]);



    const handleYearGroupChange = (event, newValue) => {
        // // console.log(newValue);
        setYearGroup(newValue);
        setApplicableClassesForYearGroup(allClassesForSubject.filter(module => module.metadata.yearGroup === newValue));
    };


    useEffect(() => {
        const applicableClasses = classToFileMap[className].sort((a, b) => a.metadata.order - b.metadata.order);
        console.log(applicableClasses);
        setAllClassesForSubject(applicableClasses);
        const availableYearGroups = Array.from(new Set([...applicableClasses.map(module => module.metadata.yearGroup)]));
        setAvailableYearGroups(availableYearGroups);
        const yearGroup = availableYearGroups[0];
        console.log(yearGroup);
        setYearGroup(yearGroup);
        setApplicableClassesForYearGroup(applicableClasses.filter(module => module.metadata.yearGroup === yearGroup));
    }, [className]);

    const navigateToPage = (module) => {
        // console.log(module);
        navigate(`/resource-hub/${encodeURIComponent(className)}/${encodeURIComponent(yearGroup)}/${encodeURIComponent(module.metadata.title)}`);
    }

    // Function to show notification via modal
    const showNotification = (message, type = 'success', url = null) => {
        setModalMessage(message);
        if (url) {
            setModalUrl(url);
        }
        setOpenModal(true);
    }

    useEffect(() => {
        // console.log('JSON data:', yourLessonJsonData);
        // console.log('Current className:', className);
        // console.log('Current keyStage:', yearGroup);

        // Filter lessons that match the current class and key stage
        if (yourLessonJsonData && Array.isArray(yourLessonJsonData)) {
            const matchingLessons = yourLessonJsonData.filter(lesson =>
                lesson.metadata &&
                lesson.metadata.classTitle === className &&
                lesson.metadata.keyStage === yearGroup
            );

            // console.log('Matching lessons:', matchingLessons);

            if (matchingLessons.length > 0) {
                // console.log('Setting currentLessonData to matching lessons');
                setCurrentLessonData(matchingLessons);
            } else {
                // console.log('No matching lessons found, setting currentLessonData to null');
                setCurrentLessonData(null);
            }
        } else {
            // console.log('Invalid JSON data format or no data available');
            setCurrentLessonData(null);
        }
    }, [className, yearGroup, yourLessonJsonData]);

 

    return (
        <MainLayout>
            <Box sx={{
                height: currentLessonData ? 'auto' : '80vh',
                p: 3,
                position: 'relative',
                display: 'flex',
                flexDirection: "column"
            }}>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    spacing={2}
                    justifyContent="space-between"
                >
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <IconButton
                            onClick={() => navigate(-1)}
                            sx={{
                                color: 'inherit',
                                '&:hover': {
                                    background: 'rgba(0, 0, 0, 0.04)'
                                }
                            }}
                        >
                            <IconArrowLeft />
                        </IconButton>
                        <Typography variant={'h3'}>
                            {className ? className : ''}
                        </Typography>
                    </Stack>

                    {/* Presentation Button - only show if we have lesson data for current class/key stage
                    {currentLessonData && (
                        <Button
                            variant="contained"
                            startIcon={<IconPresentation />}
                            onClick={generatePresentation}
                            disabled={isGeneratingPresentation}
                            sx={{
                                background: 'linear-gradient(90deg, #4c81f2, #a670bd)',
                                color: 'white',
                                fontFamily: 'Poppins',
                                '&:hover': {
                                    background: 'linear-gradient(90deg, #3b70e1, #9560ac)',
                                }
                            }}
                        >
                            {isGeneratingPresentation ? 'Creating Presentation...' : 'Create Presentation'}
                        </Button>
                    )} */}
                </Stack>

                {/* Preview Toggle */}
                {currentLessonData && (
                    <Stack direction="row" spacing={2} sx={{ mt: 2, mb: 2 }}>
                        {presentationUrl && (
                            <Button
                                variant="contained"
                                href={presentationUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    background: 'linear-gradient(90deg, #a670bd, #4c81f2)',
                                    color: 'white',
                                    fontFamily: 'Poppins',
                                    fontWeight: 'bold',
                                    padding: '8px 16px',
                                    '&:hover': {
                                        background: 'linear-gradient(90deg, #9560ac, #3b70e1)',
                                    }
                                }}
                            >
                                Open Presentation
                            </Button>
                        )}
                        <Button
                            variant="outlined"
                            startIcon={showPreview ? <IconEyeOff /> : <IconEye />}
                            onClick={() => setShowPreview(!showPreview)}
                            sx={{
                                borderColor: '#4c81f2',
                                color: '#4c81f2',
                                fontFamily: 'Poppins',
                                '&:hover': {
                                    borderColor: '#3b70e1',
                                    background: 'rgba(76, 129, 242, 0.04)'
                                }
                            }}
                        >
                            {showPreview ? 'Hide Preview' : 'Show Preview'}
                        </Button>
                    </Stack>
                )}

                {/* Year Group Tabs */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 3, paddingBottom: 0 }}>
                    {yearGroup && <Tabs
                        value={yearGroup}
                        onChange={handleYearGroupChange}
                        sx={{
                            '& .Mui-selected': {
                                background: 'linear-gradient(90deg, #4c81f2, #a670bd, #a670bd)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                            },
                            '& .MuiTabs-indicator': {
                                background: 'linear-gradient(90deg, #4c81f2, #a670bd, #a670bd)',
                            }
                        }}
                    >
                        {availableYearGroups
                            .map((yearGroup, index) => (
                                <Tab
                                    key={index}
                                    label={yearGroup}
                                    value={yearGroup}
                                    sx={{ fontFamily: 'Poppins' }}
                                />
                            ))
                        }
                    </Tabs>
                }
                </Box>

                {/* Lesson Items */}
                {applicableClassesForYearGroup?.length > 0 ? (
                    (() => {
                        // Group classes by module
                        const moduleGroups = {};
                        applicableClassesForYearGroup.forEach(module => {
                            if (!moduleGroups[module.metadata.module]) {
                                moduleGroups[module.metadata.module] = [];
                            }
                            moduleGroups[module.metadata.module].push(module);
                        });
                        
                        // Render module groups with dividers
                        return Object.entries(moduleGroups).map(([moduleName, modules], groupIndex) => (
                            <Box key={groupIndex}>
                                {groupIndex > 0 && <Divider sx={{ my: 2 }} />}
                                <Typography variant="h5" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
                                    {moduleName}
                                </Typography>
                                {modules.map((module, index) => (
                                    <Box key={index} sx={{ m: 2 }}>
                                        <Stack direction={'row'} spacing={2} alignItems={'center'}
                                            sx={{
                                                '&:hover': {
                                                    cursor: 'pointer',
                                                    scale: 1.03,
                                                    background: 'linear-gradient(90deg, #4c81f2, #a670bd, #a670bd)',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',
                                                    fontWeight: 'bold'
                                                }
                                            }}
                                            onClick={() => navigateToPage(module)}
                                        >
                                            <IconBookmarks />
                                            <Typography variant={'h4'}>{module.metadata.title}</Typography>
                                        </Stack>
                                    </Box>
                                ))}
                            </Box>
                        ));
                    })()
                ) : !currentLessonData && (
                    <Fade in={true} timeout={1000}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column' }}>
                            <Lottie animationData={animationData} loop={true} />
                            <Typography variant={'h5'}>We're creating resources for this stage, keep checking back!</Typography>
                        </Box>
                    </Fade>
                )
            }
        </Box>

        {/* Render LessonContentRenderer and Presentation Preview side by side when we have data */}
        {currentLessonData && currentLessonData.length > 0 && (
            <Box sx={{ p: 3 }}>
                {showPreview ? (
                    <Grid container spacing={3} sx={{ height: 'calc(100vh - 250px)' }}>
                        <Grid item xs={12} md={6} sx={{ height: '100%', overflowY: 'auto' }}>
                            <LessonContentRenderer
                                lessonData={currentLessonData}
                                keyStage={yearGroup}
                                className={className}
                                setSelectedLesson={setSelectedLesson}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sx={{ height: '100%' }}>
                            <SimpleGoogleSlidesPreview
                                lessonData={selectedLesson || currentLessonData[0]}
                            />
                        </Grid>
                    </Grid>
                ) : (
                    <LessonContentRenderer
                        lessonData={currentLessonData}
                        keyStage={yearGroup}
                        className={className}
                        setSelectedLesson={setSelectedLesson}
                    />
                )}
            </Box>
        )}
        {/* Modal for notifications */}
        <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="presentation-modal-title"
            aria-describedby="presentation-modal-description"
        >
            <MuiBox sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                p: 4,
            }}>
                <Typography id="presentation-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                    Presentation Created
                </Typography>
                <Typography id="presentation-modal-description" sx={{ mb: 3 }}>
                    {modalMessage}
                </Typography>
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    {modalUrl && (
                        <Button
                            variant="contained"
                            onClick={() => {
                                window.open(modalUrl, '_blank');
                                setOpenModal(false);
                            }}
                            sx={{
                                background: 'linear-gradient(90deg, #4c81f2, #a670bd)',
                                color: 'white',
                                '&:hover': {
                                    background: 'linear-gradient(90deg, #3b70e1, #9560ac)',
                                }
                            }}
                        >
                            Open Presentation
                        </Button>
                    )}
                    <Button
                        variant="outlined"
                        onClick={() => setOpenModal(false)}
                        sx={{
                            borderColor: '#a670bd',
                            color: '#a670bd',
                            '&:hover': {
                                borderColor: '#9560ac',
                                background: 'rgba(166, 112, 189, 0.04)'
                            }
                        }}
                    >
                        Close
                    </Button>
                </Stack>
            </MuiBox>
        </Modal>
    </MainLayout>
);
};

export default ClassPage;
//
// Teacher-Resource-Hub-29cd1852b43c44d182791ff574780bfd
// https://www.notion.so/Teacher-Resource-Hub-29cd1852b43c44d182791ff574780bfd
// https://notion-api.splitbee.io/v1/page/Teacher-Resource-Hub-29cd1852b43c44d182791ff574780bfd
